import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Endpoints from '../endpoints';

import { User } from '../_models/user';

@Injectable()
export class UserService {
  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get<User[]>('/api/users');
  }

  getById(id: number) {
    return this.http.get('/api/users/' + id);
  }

  createUser(username: string, password: string, name: string) {
    console.debug("username is "+username);
    let u = new User();
    u.username=username;
    u.password=password;
    u.name=name;
    return this.http.post<any>(Endpoints.CREATE_USER_ENDPOINT, JSON.stringify(u))
      .map(user => {
        console.debug("added user "+JSON.stringify(user));
        if (user.userRole=='admin') {
          return user;
        }
        else {
          let unauthenticated=new User();
          unauthenticated.userRole='unauthenticated';
        }
      });
  }

  update(user: User) {
    return this.http.put('/api/users/' + user.id, user);
  }

  delete(id: number) {
    return this.http.delete('/api/users/' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/user.service.ts